import Image from '../Image/Image';
import { getClassNameGenerator } from '../../helper/className';
import config from 'config';
import React from 'react';
import { IFrame } from '../IFrame/IFrame';
import classNames from 'classnames';

var moduleCodes = require('../../constants/moduleCodes');
var modulePaths = require('constants/modulePath');

var Link = ReactRouter.Link;

var ShortcutItem = React.createClass({

  propTypes: {
    module: React.PropTypes.object,
    isCurrentModule: React.PropTypes.bool
  },

  render: function () {
    var {module, isCurrentModule} = this.props;
    module = module || {};

    var itemRoute = this._getItemRoute(module);
    var itemClassName = this._getItemClassName(module, isCurrentModule);
    var itemIcon = this._getItemIcon(module);
    var hasItemTitle = this._hasItemTitle(module);
    var itemTitle = this._getItemTitle(module);

    if (this._isHtmlBasedLogo(module)) {
      return (
        <li>
          <div className={classNames(itemClassName, 'esk-module-logo-dynamic')}>
            <span className="iconbox">
              {itemIcon}
              <span display-if={hasItemTitle} className="iconbox-title">
								<span>{itemTitle}</span>
							</span>
						</span>
            <Link display-if={!module.url} className="esk-module-logo-dynamic__link" to={itemRoute} />
            <a display-if={module.url} className="esk-module-logo-dynamic__link" href={module.url} target="_blank" />
          </div>
        </li>
      );
    }

    return (
      <li>
        <Link to={itemRoute} className={itemClassName}>
						<span className="iconbox">
              {itemIcon}
							<span display-if={hasItemTitle} className="iconbox-title">
								<span>{itemTitle}</span>
							</span>
						</span>
        </Link>
      </li>
    )
  },

  _getItemRoute(module) {
    if (module.isCustom) {
      return modulePaths.createCustomModulePath(module.code);
    }
    return `/${modulePaths[module.code]}`;
  },

  _getItemClassName(module, isCurrentModule) {
    var selectedClass = this._getSelectedClass(isCurrentModule);
    var moduleClass = this._getModuleClass(module.code);
    var itemClassName = "jarvismetro-tile big-cubes " + selectedClass + moduleClass;
    return itemClassName;
  },

  _getSelectedClass(isCurrentModule) {
    var selectedClass = isCurrentModule ? " selected" : "";
    return selectedClass;
  },

  _getModuleClass(moduleCode) {
    const baseImageContainerClassName = 'esk-module-logo-container';
    const getBaseImageContainerClassName = getClassNameGenerator(baseImageContainerClassName);

    const createClassName = (moduleClass, bgClass) =>
      ` ${baseImageContainerClassName} ${getBaseImageContainerClassName(moduleClass, true)} ${bgClass}`;

    switch (moduleCode) {
      case moduleCodes.MODULE_RA:
        return createClassName(moduleCodes.MODULE_RA, 'bg-color-pinkDark');
      case moduleCodes.MODULE_ADMIN:
        return createClassName(moduleCodes.MODULE_ADMIN, 'bg-color-greenLight');
      case moduleCodes.MODULE_INSPECTION_COACH:
        return createClassName(moduleCodes.MODULE_INSPECTION_COACH, 'bg-color-white');
      case moduleCodes.MODULE_INSPECTION_CENTRE:
        return createClassName(moduleCodes.MODULE_INSPECTION_CENTRE, 'bg-color-white');
      case moduleCodes.MODULE_2BAP:
        return createClassName(moduleCodes.MODULE_2BAP, 'bg-color-white');
      default:
        return " bg-color-pinkDark";
    }
  },

  _isImageBasedLogo(moduleCode) { return Boolean(this._getImageLogoUrl(moduleCode)); },
  _getImageLogoUrl(moduleCode) { return config.logoConfig.getModulePreviewLogo(moduleCode); },

  _isHtmlBasedLogo(module) { return module.isCustom; },
  _getHtmlLogoUrl(moduleCode) { return config.logoConfig.getCustomModulePreviewLogoHTML(moduleCode); },

  _getItemIcon(module) {
    if (this._isHtmlBasedLogo(module) && this._getHtmlLogoUrl(module.code)) {
      return <IFrame src={this._getHtmlLogoUrl(module.code)} />;
    } else if (this._isImageBasedLogo(module.code)) {
      return <Image className="esk-module-logo" src={this._getImageLogoUrl(module.code)} />
    } else {
      return <i className={this._getItemIconClassName(module)} />;
    }
  },

  _getItemIconClassName(module) {
    var itemIcon = "fa fa-3x";

    switch (module.code) {
      case moduleCodes.MODULE_RA:
        itemIcon = itemIcon + " fa-book";
        break;
      case moduleCodes.MODULE_ADMIN:
        itemIcon = itemIcon + " fa-cogs";
        break;
      case moduleCodes.MODULE_INSPECTION_COACH:
        itemIcon = itemIcon + " fa-mortar-board";
        break;
      case moduleCodes.MODULE_INSPECTION_CENTRE:
        itemIcon = itemIcon + " fa-table";
        break;
      case moduleCodes.MODULE_2BAP:
        itemIcon = itemIcon + " fa-users";
        break;
      default:
        itemIcon = itemIcon + " fa-user";
        break;
    }
    return itemIcon;
  },

  _hasItemTitle(module) {
    return !this._isHtmlBasedLogo(module) && !this._isImageBasedLogo(module.code);
  },

  _getItemTitle(module) {
    return module.title;
  }

});

module.exports = ShortcutItem;
